import React, { useMemo, type ReactNode } from 'react';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';

import { LEARN_MORE_LINK, LEARN_MORE_LINK_JSW } from '../../common/constants';
import type { ImportType } from '../../common/constants/import-type';
import { ProjectTypes } from '../../common/constants/project';
import { EXISTING_PROJECT } from '../../common/constants/source';
import { useContentForCSV } from '../../common/utils/get-content-for-csv';
import { useProjectData, useSource } from '../../controllers/import-state/selectors';
import messages from './messages';

export const useContent = (importType?: ImportType) => {
	const [source] = useSource();
	const [{ name, type }] = useProjectData();
	const { formatMessage } = useIntl();
	const { uploadScreenDescription } = useContentForCSV(importType);

	return useMemo(() => {
		if (source === EXISTING_PROJECT) {
			return {
				heading: formatMessage(messages.headingExistingProject, { projectName: name }),
				description: formatMessage(messages.descriptionExistingProject, {
					link: (content: ReactNode) => (
						<Button
							href={type === ProjectTypes.SOFTWARE ? LEARN_MORE_LINK_JSW : LEARN_MORE_LINK}
							target="_blank"
							appearance="link"
							spacing="none"
						>
							{content}
						</Button>
					),
				}),
			};
		}
		return {
			heading: formatMessage(messages.heading),
			description: uploadScreenDescription,
		};
	}, [formatMessage, name, source, type, uploadScreenDescription]);
};
